import { useTranslation } from 'react-i18next';
import { ProductsView } from './sections/ProductsView';

export default function ExploreProducts() {
  const { t } = useTranslation('product');

  return (
    <div className="space-y-6">
      <title>{t('product.title')}</title>
      <div>
        <h1 className="text-2xl sm:text-3xl text-neut-prim mb-2">
          {t('product.title')}
        </h1>
        <p className="text-sm text-neut-sec">{t('product.description')}</p>
      </div>
      <ProductsView />
    </div>
  );
}
